/**
 * Ryan O'Dowd
 * 2026-01-10
 * © Copyright 2026 Oakwood Software Consulting, Inc. All Rights Reserved.
 */
import React, {
  useState,
} from 'react';
import {
  setGoalHideCompleted,
  setGoalShowCompleted,
} from '@utils/store/actions';
import Badge from '@components/common/Badge';
import IconButton from '@components/common/IconButton';
import Menu from '@components/common/Menu';
import {
  View,
} from 'react-native';
import getStyles from './styles';
import hooks from '@hooks';

const ToggleCompletedVisibilityButton = (props: ToggleCompletedVisiblityButtonProps) => {
  const styles = hooks.useStyles(getStyles);
  const dispatch = hooks.useTypedDispatch();

  const [_isMenuOpen, setIsMenuOpen] = useState(false);

  const hideCompletedAssignments = hooks.useTypedSelector((state) => !!state.hideCompletedByGoalId[props.goalId]);

  return (
    <Menu
      statusBarHeight={styles.safeAreaInsets.top}// @TODO: abstract menu to oak component and abstract this prop away
      anchor={
        <View>
          <IconButton
            mode='contained'
            icon={hideCompletedAssignments ? 'eye-off' : 'eye-check'}
            theme={props.theme}
            iconColor={props.compact ? props.theme : (styles.isDarkMode ? styles.colors.primaryDark : styles.colors.primaryExtraLight)}
            containerColor={props.compact ? 'transparent' : (styles.isDarkMode ? styles.colors.primary : styles.colors.primaryLight)}
            contentStyle={props.compact ? styles.compactContentStyles : undefined}
            style={props.compact ? styles.compactContentStyles : undefined}
            onPress={() => setIsMenuOpen(true)}
          />
          {!props.hideBadge && !!props.numCompleted && <Badge color={styles.colors.accent} size={18}>{props.numCompleted}</Badge>}
        </View>
      }
      visible={_isMenuOpen}
      onDismiss={() => setIsMenuOpen(false)}
    >
      <Menu.Item
        title='Hide completed'// @TODO: i18n
        isTextBold={hideCompletedAssignments}
        onPress={() => {
          setIsMenuOpen(false);
          dispatch(setGoalHideCompleted(props.goalId));
        }}
      />
      <Menu.Item
        title='Show completed'// @TODO: i18n
        isTextBold={!hideCompletedAssignments}
        onPress={() => {
          setIsMenuOpen(false);
          dispatch(setGoalShowCompleted(props.goalId));
        }}
      />
    </Menu>
  );
};

class ToggleCompletedVisiblityButtonProps {
  goalId: number;
  theme: any;

  numCompleted?: number;
  compact?: boolean;
  hideBadge?: boolean;
};

export default ToggleCompletedVisibilityButton ;
